import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import withMatchMediaProps from "@hocs/with-match-media-props";
import { fetchNewsletterDetail } from "actions/newsletterActions";
import { isNewsletterPDF } from "../../utils";

const Newsletter = ({ item, isNarrowScreen }) => {
  const { key, title, summary, coverImage, newsletterFile } = item;
  useEffect(() => {
    fetchNewsletterDetail(key);
  }, []);
  if (!item) {
    return null;
  }

  const ItemLink = props => <Link to={`/wellness/newsletters/${key}`} {...props} />;
  return (
    <article className="grid__item grid__item--three apl-showcase__item">
      {coverImage && (
        <figure>
          {!isNewsletterPDF(newsletterFile) ? (
            <ItemLink>
              <img src={coverImage} alt="" />
            </ItemLink>
          ) : (
            <a href={newsletterFile} target="_blank" rel="noreferrer">
              <img src={coverImage} alt="" />
            </a>
          )}
        </figure>
      )}
      <header>
        <h4>
          {!isNewsletterPDF(newsletterFile) ? (
            <ItemLink>{title}</ItemLink>
          ) : (
            <a href={newsletterFile} target="_blank" rel="noreferrer">
              {title}
            </a>
          )}
        </h4>
      </header>
      <section>
        <div dangerouslySetInnerHTML={{ __html: summary }} />
      </section>
    </article>
  );
};

Newsletter.propTypes = {
  item: PropTypes.object.isRequired,
  isNarrowScreen: PropTypes.bool,
};

export default withMatchMediaProps({
  isNarrowScreen: {
    maxWidth: 680,
  },
})(Newsletter);



// WEBPACK FOOTER //
// ./components/wellness/Newsletter.jsx